export default {
  default: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/layouts/default.vue").then(m => m.default || m),
  error: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/layouts/error.vue").then(m => m.default || m),
  landing: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/layouts/landing.vue").then(m => m.default || m),
  shopping: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/layouts/shopping.vue").then(m => m.default || m),
  simple: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/layouts/simple.vue").then(m => m.default || m)
}